export const facilitatorContracts = {
  tabTitle: 'Facilitator requirements',
  refresh: 'Refresh facilitators',
  selectOrganisation: 'Please select an organisation to view facilitators.',
  sendTitle: 'Send contract to sign',
  sendHint:
    'This goes only to the facilitators you selected. You can add or remove people here, or include extra email addresses. Each person receives a private link to read and sign.',
  sendThenSelectHint:
    'Select the facilitators to send to, then press Send contract. It only goes to the people you tick, not everyone.',
  sendButton: 'Send contract',
  sendButtonWithCount: 'Send contract ({{count}})',
  sendNeedsSelection: 'Select at least one facilitator first.',
  selectAllFacilitators: 'Select all facilitators',
  selectFacilitator: 'Select {{name}}',
  selectTemplate: 'Agreement to send',
  noTemplatesHint: 'Add a contract for this organisation first. You can start from the Awe & Wander agreement or write a new one.',
  templatesTitle: 'Contracts',
  templatesHint: 'Add a separate agreement for each project, then send it to the people who need to sign.',
  templatesEmpty: 'No contracts yet',
  templatesEmptyHint: 'Add an agreement for this organisation. You can start from the Awe & Wander facilitator agreement.',
  addTemplate: 'Add contract',
  editTemplate: 'Edit contract',
  templateHint: 'Give this agreement a name (usually the project) and paste or write the terms in markdown.',
  templateTitle: 'Agreement name',
  linkProject: 'Linked project',
  linkProjectHint:
    'Optional. Choose the budget tracker / project timeline this agreement belongs to. Facilitators who are sent this contract can then see that project’s documents.',
  noLinkedProject: 'Not linked to a project',
  templateBody: 'Agreement text',
  templateBodyHint: 'Markdown is supported. Recipients see this text on the signing page.',
  startFromAweWander: 'Start from Awe & Wander agreement',
  templateSaved: 'Contract saved.',
  templateDeleted: 'Contract deleted.',
  deleteTemplateTitle: 'Delete this contract?',
  deleteTemplateMessage:
    'People who already received a signing link keep their copy. You will not be able to send this version again.',
  checklistHeader: 'Contracts',
  checklistSigned: 'Signed {{date}}',
  checklistAwaiting: 'Awaiting signature',
  checklistNotSent: 'Not sent',
  checklistEmpty: 'No contracts to track yet.',
  checklistMissing: 'Not signed: {{title}}',
  overrideSigned: 'Mark as signed',
  overrideNotSigned: 'Mark as not signed',
  agreement: 'Agreement',
  selectFacilitators: 'Facilitators',
  extraEmails: 'Extra email recipients',
  extraEmailsHint: 'One per line. You can use Name <email@domain> or just an email address.',
  personalNote: 'Personal note',
  personalNoteHint:
    'Optional. Added to the email for everyone you are sending to. Leave blank for the standard message.',
  emailPreview: 'Email preview',
  emailPreviewHint:
    'Each person is greeted by their own name and receives a private signing link. This is an example of the wording.',
  emailPreviewRecipientPlaceholder: "[recipient's name]",
  emailPreviewLinkPlaceholder: '[signing link]',
  companySignatoryName: 'Signed for Overhear Ltd by',
  companySignatoryPosition: 'Position',
  preview: 'Preview agreement',
  sentSuccess: 'Contract sent.',
  sentCount: 'Sent {{count}} contract link(s).',
  sendFailed: 'Could not send the contract. Please try again.',
  signFailed: 'Could not sign the agreement. Please try again.',
  copyFailed: 'Could not copy the link.',
  notSignedIn: 'Sign in to send contracts.',
  requestsTitle: 'Contracts sent',
  requestsEmpty: 'No contracts have been sent yet.',
  status: 'Status',
  statusSent: 'Awaiting signature',
  statusSigned: 'Signed',
  resend: 'Resend link',
  copyLink: 'Copy link',
  linkCopied: 'Signing link copied.',
  resent: 'Signing link resent.',
  recipient: 'Recipient',
  signedAt: 'Signed',
  open: 'Open',
  signTitle: 'Sign agreement',
  signIntro: 'Please read this agreement, then complete your details and type your name as your signature.',
  alreadySignedTitle: 'Agreement signed',
  alreadySignedBody: 'Thank you. This agreement was signed on {{date}}.',
  notFoundTitle: 'Agreement not found',
  notFoundBody: 'This signing link is not valid. Ask Overhear to send the contract again.',
  fullName: 'Full name',
  address: 'Address',
  phone: 'Phone',
  email: 'Email',
  signature: 'Type your name as your signature',
  signatureHint: 'This is your electronic signature for this agreement.',
  agreeLabel: 'I have read this agreement and agree to its terms.',
  submit: 'Sign agreement',
  submitting: 'Signing…',
  signedThanks: 'Thank you. Your signed agreement has been sent to Overhear.',
  companyBlock: 'For Overhear Ltd',
  facilitatorBlock: 'Facilitator',
  date: 'Date',
  position: 'Position',
  validation: {
    nameRequired: 'Please enter your full name.',
    addressRequired: 'Please enter your address.',
    emailRequired: 'Please enter your email address.',
    emailInvalid: 'Please enter a valid email address.',
    signatureRequired: 'Please type your name as your signature.',
    agreeRequired: 'Please confirm you agree to this agreement.',
    recipientsRequired: 'Select at least one facilitator or add an email recipient.',
    companyNameRequired: 'Enter who is signing for Overhear Ltd.',
    companyPositionRequired: 'Enter their position.',
    extraEmailInvalid: 'Check the extra email addresses. Use one valid address per line.',
    templateRequired: 'Select which agreement to send.',
    templateTitleRequired: 'Enter a name for this agreement.',
    templateBodyRequired: 'Enter the agreement text.',
  },
};
